import { defineNuxtPlugin } from "nuxt/app";
import mitt from "mitt";
import type Emitter from "~/types/Emitter";

const emitter = mitt();

export default defineNuxtPlugin(() => {
  const bus: Emitter = {
    $on: emitter.on,
    $off: emitter.off,
    $emit: emitter.emit,
  };

  return {
    provide: {
      bus,
    },
  };
});
